type TSettingsTabIds =
  | 'general'
  | 'notifications'
  | 'risk'
  | 'integrations'
  | 'packages'
  | 'team';

export const SETTINGS_TABS: Array<{ id: TSettingsTabIds; title: string }> = [
  { id: 'general', title: 'General' },
  { id: 'notifications', title: 'Notifications' },
  { id: 'risk', title: 'Risk settings' },
  { id: 'integrations', title: 'Integrations' },
  { id: 'packages', title: 'Packages' },
  { id: 'team', title: 'Team' },
];
